import dayjs from "dayjs"
import updateLocale from "dayjs/plugin/updateLocale"
import "dayjs/locale/ko"

dayjs.extend(updateLocale)

// 한국어 월을 숫자로 바꿈
// dayjs.updateLocale("ko", {
//   months: [
//     "01", "02", "03", "04", "05", "06",
//     "07", "08", "09", "10", "11", "12"
//   ],
//   monthsShort: [
//     "01", "02", "03", "04", "05", "06",
//     "07", "08", "09", "10", "11", "12"
//   ]
// })